import * as yup from 'yup';

export const price = yup.object().shape({
  total: yup
    .number()
    .typeError('Número no válido')
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
});
